import React from "react";
import Tag from "./tag.jsx";

class TagList extends React.Component {
  render() {
    var { tags, tooltip, onClick, style } = this.props;

    return (
      <div style={style}>
        {tags
          .filter(tag => typeof tag.visible === 'undefined' ? true : tag.visible)
          .map(t => {
            return (
              <Tag
                key={t.id || t.name || t}
                content={t}
                tooltip={tooltip}
                onClick={onClick ? e => onClick(t) : undefined}
              />
            );
          })}
      </div>
    );
  }
}

export default TagList;



// WEBPACK FOOTER //
// ./src/app/components/partials/tag-list.jsx